import Regulations from "./Regulations"

export default Regulations
